module.exports = "img/flags/ML.6217ef5.png";